import React, { useState } from "react";
import { Outlet } from "react-router-dom";
import { List, X } from "@phosphor-icons/react";
import { SidebarContent } from "@/components/customer/Sidebar";
import { OtmLogo } from "@/components/common/OtmLogo";
import { Sheet, SheetContent, SheetTitle } from "@/components/ui/sheet";
import { ASSETS } from "@/lib/assets";

export default function CustomerLayout() {
  const [open, setOpen] = useState(false);
  return (
    <div className="h-[100dvh] w-full overflow-hidden bg-[#050505] text-neutral-100 flex">
      {/* Desktop sidebar */}
      <aside className="hidden lg:flex w-64 shrink-0 bg-[#0F0F0F] border-r border-neutral-800 flex-col py-6 px-4">
        <SidebarContent />
      </aside>

      {/* Mobile sheet */}
      <Sheet open={open} onOpenChange={setOpen}>
        <SheetContent side="left" className="w-72 bg-[#0F0F0F] border-neutral-800 p-4 pt-6">
          <SheetTitle className="sr-only">Navigation menu</SheetTitle>
          <SidebarContent onNavigate={() => setOpen(false)} />
        </SheetContent>
      </Sheet>

      <div className="flex-1 flex flex-col min-w-0">
        {/* Mobile top bar */}
        <div className="lg:hidden flex items-center justify-between px-4 h-14 pt-[env(safe-area-inset-top)] box-content border-b border-neutral-800 bg-[#0F0F0F] shrink-0">
          <button onClick={() => setOpen(true)} data-testid="mobile-menu-button" className="text-neutral-300 hover:text-white">
            <List size={24} />
          </button>
          <OtmLogo showCaravans={false} imgClassName="h-6" />
          <div className="w-6" />
        </div>
        <main className="flex-1 min-h-0 overflow-hidden relative">
          <div className="pointer-events-none absolute inset-0 z-0" aria-hidden="true">
            <div
              className="absolute inset-0 bg-cover bg-center opacity-30 grayscale"
              style={{ backgroundImage: `url(${ASSETS.backdrop})` }}
            />
            <div className="absolute inset-0 bg-gradient-to-b from-[#050505]/55 via-[#050505]/78 to-[#050505]" />
          </div>
          <div className="relative z-10 h-full">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
}
